import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _QualityInspectionLote, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { FileService } from "../../../../core/services/FileService";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { FileInput } from "../../../theme/Component/FileInput";
import { VisorAnyDocument } from "../../../documents/VisorAnyDocument";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { InputDate } from "../../../theme/Input/InputDate";
import { QualityInspectionLoteItem } from "./QualityInspectionLoteItem/QualityInspectionLoteItem";
import usePaginator from "../../../theme/Component/usePaginator";


interface ComponentData {
    isModal?: boolean;
    _Lot: any;
}

export const QualityInspectionLote = ({ _Lot, isModal }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityInspectionLote);
    const fileservice = new FileService();
    const paginator = usePaginator();

    const [state, setState] = useState<number>(1);

    const modal = useModal("", MODAL_md)
    const modalChange = useModal("", MODAL_SM);
    const modalDocument = useModal("Cargar Documento Firmado", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);
    const modalItems = useModal("", MODAL_md);

    useEffect(() => {
        if (_Lot.IDLot) {
            getLista();
            getProductbyOrder();
        } else {
            setLista([]);
        }
    }, [_Lot, paginator.page])

    const getLista = () => {
        let props: any = {
            IDLot: _Lot.IDLot
        }

        if (state) props.State = state;

        instance.getQualityInspectionLoteRender(paginator.page, 15, props).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach((element) => {
                    const d = element.DataBeanProperties;

                    d.UserEntity = d.IDEmployee ? `${d.EmployeeNit} - ${d.EmployeeFullName}` : "N/A";
                    d.POrderEntity = d.IDProductionOrder ? `OP ${d.IDProductionOrder} - ${d.ProductionOrderDate} - Código ${d.POCode}` : "N/A";
                })
                setLista(resp.List);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        instance.getProductionOrderByYearAndProductionOrder(_Lot.IDProductionOrder).then(
            (resp) => {
                const value = resp[0].DataBeanProperties.IDProject;
                
                setBean({
                    State: 1,
                    IDLot: _Lot.IDLot,
                    IDProductionOrder: _Lot.IDProductionOrder,
                    FillingDate: _single.getCurrenDate(),
                    IDEmployee: _single.getAccountID(),
                    IDProduct: value
                });
                modal.open("Agregar Inspección de Lote")
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const head = [
        { title: 'ID', property: 'IDQualityInspectionLote', visible: true },
        { title: 'Fecha de Diligenciamiento', property: 'FillingDate', visible: true },
        { title: 'Producto', property: 'ProductDescription', visible: true },
        { title: 'Orden', property: 'POrderEntity', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Empleado', property: 'UserEntity', visible: true },
    ]

    const [confirmAction, setConfirmAction] = useState<() => void>(() => () => { });

    const openConfirm = (text: string, fn: () => void) => {
        setConfirmAction(() => fn);
        modalChange.open(text)
    };

    const changeStateItem = (newState: number) => {
        let x = { ...bean, State: newState };


        editaItem(x);
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Inspección de Lote") } },
            { titulo: 'Cargar Documento Firmado', icono: 'mdi mdi-file-upload', visible: _single.canEdit(), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.DocMedia, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Ver Uniformes', icono: 'mdi mdi-table-edit', visible: true, evento: () => { modalItems.open("Uniformes de Muestreo") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && bean.State == 1, evento: () => { openConfirm("Confirmar Eliminación", () => changeStateItem(3)) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getProductbyOrder = () => {

    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionLote(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalChange.close();
                modalDocument.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "FillingDate", "Quantity"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <label>Estado</label>
                    <select value={state} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null
                        setState(value)
                    }} className="form-select">
                        <option value="">...</option>
                        <option value="1">Creado</option>
                        <option value="3">Eliminado</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        pageTop={paginator.page}
                        next={paginator.next}
                        back={paginator.back}
                        records={paginator}
                    />
                </div>
                <div className="col-md-12">

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('FillingDate') ? 'has-error' : ''}`} >Fecha de Diligenciamiento</label>
                                <InputDate name="" value={bean.FillingDate} setDate={(e) => { setBean({ ...bean, FillingDate: e }) }} label=" " />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Quantity') ? 'has-error' : ''}`} >Numero de Muestras</label>
                                <input type="number" value={bean.Quantity} onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, Quantity: value })
                                }} className="form-control" />
                            </div>

                        </div>
                    </Modal>

                    <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { editaItem(bean) }}  >
                        <FileInput onCreate={(e) => { setBean({ ...bean, DocMedia: e.Media, DocMediaContext: e.MediaContext }) }} Media={bean.DocMedia} MediaContext={bean.DocMediaContext} directory="quality" docAcept={"application/pdf"} label="Documento Firmado" />
                    </Modal>

                    <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                        <VisorAnyDocument type="pdf" url={fileservice.getUrlFile(bean.DocMediaContext, bean.DocMedia)} />
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal}   >
                        <QualityInspectionLoteItem QualityInspectionLote={bean} />
                    </Modal>

                    <ModalConfirm modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { confirmAction() }}>
                        <strong>¿Desea Continuar con la accion?</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Calidad - Lotes de Producto">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}